<template>
  <div v-if="loaded">
    <b-alert v-if="isSuccess" variant="success" show>
      <div class="header">Payment Complete</div>
      <div>
        We have received your payment. If you have an account you will see this
        on your dashboard shortly.
      </div>
      <div class="button-holder">
        <b-button @click="goToDashboard">Go to dashboard</b-button>
      </div>
    </b-alert>

    <b-alert v-if="!isSuccess" variant="danger" show>
      <div class="header">Payment Incomplete</div>
      <div>
        We were unable to complete your payment. To try again, please click
        below to return to your account dashboard
      </div>
      <div class="button-holder">
        <b-button @click="goToDashboard">Go to dashboard</b-button>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { router } from "@/router";

export default {
  name: "ExternalPayment",
  props: {
    apartment: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      isSuccess: false,
      isCreditBilling: false,
      shouldAlert: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    runFailure() {
      const title = "Access Error";
      const subtitle = "We were unable to load your payment";
      this.$store.dispatch("pushError", { title, subtitle });
      router.push("/login");
    },
    runAlert() {
      const type = this.isSuccess ? "pushSuccess" : "pushError";
      const title = this.isSuccess ? "Payment received" : "Payment incomplete";
      const subtitle = this.isSuccess
        ? "Your payment will update on your dashboard after processing"
        : "We were unable to take your payment, please try again";
      this.$store.dispatch(type, { title, subtitle });
    },
    goToDashboard() {
      if (this.shouldAlert) {
        this.runAlert();
      }
      if (this.isCreditBilling) {
        router.push(
          "/billing/" + this.apartment + "?ext-payment=" + this.state
        );
        return;
      }

      router.push("/prepay/" + this.apartment + "?ext-payment=" + this.state);
    },
    setup() {
      if (
        !["success-c", "error-c", "success-p", "error-p"].includes(this.state)
      ) {
        this.runFailure();
        return;
      }

      if (["success-c", "error-c"].includes(this.state)) {
        this.isCreditBilling = true;
      }

      if (["success-c", "success-p"].includes(this.state)) {
        this.isSuccess = true;
      }

      this.loaded = true;

      if (this.isLoggedIn) {
        this.shouldAlert = true;
        this.goToDashboard();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  font-size: 0.9rem;
  margin-top: 2rem;

  .header {
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .button-holder {
    margin-top: 5vh;
  }
}
</style>
